import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const Styles = StyleSheet.create({
  whiteBackground: {
    backgroundColor: 'white',
  },
  selectAvatarImageContainer: {
    width: 120,
    height: 120,
    maxWidth: '35vw',
    maxHeight: '35vw',
  },
  selectAvatarImage: {
    borderRadius: 164 / 2,
    overflow: 'hidden',
    // https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
    WebkitMaskImage: '-webkit-radial-gradient(white, black)',
  },
  selectAvatarEditIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    padding: 4,
  },
  field: {
    backgroundColor: Colors.v2.gray05,
    borderRadius: grid(1),
    borderWidth: 0,
    paddingVertical: 16,
    paddingHorizontal: 16,
  },
  fieldError: {
    backgroundColor: Colors.v2.actionTropicalRed10,
  },
});
